__webpack_require__.p = "https://localhost:4000/app/themes/treasureinside/dist/";